import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

const useStyles = makeStyles((theme) =>
    createStyles({
        messagesSection: {
            // marginBottom: '55px !important',
            [theme.breakpoints.down('sm')]: {
                padding: '15px',
            },
            width: '100%'
        },
        buttonContainer: {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'flex-start'
        }
    }),
);

export default useStyles;